<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Asociar Factura</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            Favor ingrese la factura correspondiente a las OOCC:

            <ul>
                <li *ngFor="let oocc of data.oocc">
                    <strong> {{ oocc.numero }}</strong>
                </li>
            </ul>

            <form
                class="form"
                [formGroup]="formFactura"
                autocomplete="off"
                class="mt-16"
            >
                <mat-form-field class="full-width">
                    <mat-label>Monto Bruto </mat-label>
                    <input
                        matInput
                        type="number"
                        formControlName="montoBruto"
                        required
                    />

                    <mat-error *ngIf="montoBruto.hasError('required')">
                        Debe ingresar valor bruto de la factura
                    </mat-error>
                    <mat-error *ngIf="montoBruto.hasError('min')">
                        El monto bruto no puede ser menor a 0
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>IVA </mat-label>
                    <input
                        matInput
                        type="number"
                        formControlName="iva"
                        required
                    />

                    <mat-error *ngIf="iva.hasError('required')">
                        Debe ingresar el valor del Iva
                    </mat-error>
                    <mat-error *ngIf="iva.hasError('min')">
                        El monto bruto no puede ser menor a 0
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Nro. Factura </mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="nroFactura"
                        required
                    />

                    <mat-error *ngIf="nroFactura.hasError('required')">
                        Debe ingresar el nro. de factura
                    </mat-error>
                    <mat-error *ngIf="nroFactura.hasError('maxlength')">
                        El numero de la factura no puede ser superior a 10
                        caracteres
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="pr-sm-8" class="full-width">
                    <mat-label>Fecha</mat-label>
                    <input
                        matInput
                        [matDatepicker]="fechaFacturaDatePicker"
                        name="fecha"
                        formControlName="fecha"
                        readonly
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="fechaFacturaDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #fechaFacturaDatePicker></mat-datepicker>
                    <mat-error *ngIf="fecha.hasError('required')">
                        Debe ingresar la fecha de la factura
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formFactura.value"
            [disabled]="!formFactura.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
